module.exports = {"id":"239718","name":"Hassane Bandé","rating":"71","photo":"./data/images/photos/1/239718.png","club":{"name":"FC Malines","logo":"./data/images/clubs/FCMalines.png"},"positions":["BU","MG","ATT"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HassaneBande0.json
// module id = 1706
// module chunks = 0